import { render } from "../../templates/partner-cart-scoring-value.html?vue&type=template&id=56a0a8bc"
import script from "./scoring-value.vue?vue&type=script&lang=js"
export * from "./scoring-value.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/lbr.ru/crm/vue_source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__